import * as React from 'react';
import { FC, useEffect, useState } from 'react';
import MainComponent from '../../../components/custom/mainComponent';
import { getDataBy } from '../../../actions/apiCall';
import { useDispatch } from 'react-redux';
import CustomModal from '../../../components/custom/Modal';
import PdfView from '../../../components/custom/PDFView';
import { List, Typography } from 'antd';
const { Title, Text } = Typography;

const UserPolicy: FC<any> = () => {
    const dispatch = useDispatch();
    const [policyData, setPolicyData] = useState([]);
    const [isOpenPdf, setOpenPdf] = useState(false);
    const [policyName, setPolicyName] = useState('');
    const [pdfUrl, setPdfURL] = useState('');

    useEffect(() => {
        const getApi = async () => {
            const resData = await dispatch(getDataBy('/policy/list'));
            setPolicyData(resData.data);
        };
        getApi();
    }, []);

    const onOpen = (policy) => {
        setOpenPdf(true);
        setPolicyName(policy?.name);
        setPdfURL(policy?.policy);
    };

    const onClose = () => {
        setOpenPdf(false);
        setPolicyName('');
        setPdfURL('');
    };

    return (
        <>
            <div className="-mt-6">
                <MainComponent
                    title="User Policy"
                    pageName="Policies"
                    controls={null}
                    isSearch={false}
                >
                    <CustomModal
                        isVisible={isOpenPdf}
                        title={policyName}
                        onClose={() => onClose()}
                    >
                        <PdfView url={process.env.FILE_URL + pdfUrl} />
                    </CustomModal>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {policyData.map(ele => (
                            <div className="" key={ele._id}>
                                <Title level={5}>{ele.name}</Title>
                                <List
                                    size="small"
                                    itemLayout="horizontal"
                                    split={false}
                                    className="!p-0"
                                    dataSource={ele.policyData}
                                    renderItem={(item: any) => (
                                        <List.Item className='!p-0'>
                                            <Text
                                                className="text-blue-600 cursor-pointer"
                                                onClick={() => onOpen(item)}
                                            >
                                                {item?.name}
                                            </Text>
                                        </List.Item>
                                    )}
                                />
                            </div>
                        ))}
                    </div>
                </MainComponent >
            </div>
        </>
    );
};

export default UserPolicy;

